import { ConfigParams } from '../config-types';
import { ActivityUrlConfig } from './activity';
import { ContentUrlConfig } from './content';
import { ProductUrlConfig } from './product';

export const RedirectConfig: Array<ConfigParams> = [
  ...ActivityUrlConfig,
  ...ContentUrlConfig,
  ...ProductUrlConfig,
];
